/* ============================================================================
   VEDIC CRYSTALS — Remedy Finder Widget JS
   ============================================================================ */
(function () {
  'use strict';

  var WORKER_URL = window.VRF_WORKER_URL || 'https://late-grass-18d9.gauravbsharma.workers.dev/';
  var GEMSTONE_REPORT_URL = '/products/gemstone-recommendation-report';
  var CACHE_KEY_PREFIX = 'vrf_result_';
  var CACHE_TTL_MS = 24 * 60 * 60 * 1000;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return (root || document).querySelectorAll(sel); }

  function buildOptions(start, end, padTo) {
    var html = '<option value="">--</option>';
    for (var i = start; i <= end; i++) {
      var v = padTo ? String(i).padStart(padTo, '0') : i;
      html += '<option value="' + i + '">' + v + '</option>';
    }
    return html;
  }
  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  function buildMonthOptions() {
    var html = '<option value="">--</option>';
    for (var i = 0; i < 12; i++) html += '<option value="' + (i + 1) + '">' + MONTHS[i] + '</option>';
    return html;
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  function tzOffset(hours) {
    var sign = hours >= 0 ? '+' : '-';
    var abs = Math.abs(hours);
    var h = Math.floor(abs);
    var m = Math.round((abs - h) * 60);
    return sign + String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0');
  }

  function getTzOffsetForLocation(tzName, dateStr) {
    if (!tzName) return '+00:00';
    try {
      var d = new Date(dateStr || new Date());
      var local = new Date(d.toLocaleString('en-US', { timeZone: tzName }));
      var utc = new Date(d.toLocaleString('en-US', { timeZone: 'UTC' }));
      var diffH = (local - utc) / 3600000;
      return tzOffset(diffH);
    } catch (e) { return '+00:00'; }
  }

  function init(root) {
    if (!root || root.dataset.vrfInit) return;
    root.dataset.vrfInit = '1';
    root.innerHTML = renderEmpty();
    bindForm(root);
  }

  function renderEmpty() {
    return [
      '<div class="vrf-center">',
        '<div class="vrf-eyebrow">Free Vedic Remedy Finder</div>',
        '<h1 class="vrf-headline">Your <em>Lucky Gemstone</em>, Rudraksha &amp; Puja<br>as per Your Birth Chart</h1>',
        '<p class="vrf-subhead">Lagna-based remedy, curated by our panel of <strong>124+ Vedic astrologers</strong>.</p>',
        '<form class="vrf-form" novalidate>',
          '<div class="vrf-row">',
            '<div class="vrf-field">',
              '<label class="vrf-label" for="vrf-day">Birth Date</label>',
              '<div class="vrf-trio">',
                '<select id="vrf-day" name="day" required aria-label="Day">' + buildOptions(1, 31) + '</select>',
                '<select id="vrf-month" name="month" required aria-label="Month">' + buildMonthOptions() + '</select>',
                '<select id="vrf-year" name="year" required aria-label="Year">' + buildYearOptions() + '</select>',
              '</div>',
            '</div>',
            '<div class="vrf-field">',
              '<label class="vrf-label" for="vrf-hour">',
                '<span>Birth Time</span>',
                '<a href="' + GEMSTONE_REPORT_URL + '" class="vrf-label-help" data-vrf="no-time">Don\'t know? →</a>',
              '</label>',
              '<div class="vrf-trio">',
                '<select id="vrf-hour" name="hour" required aria-label="Hour">' + buildOptions(1, 12) + '</select>',
                '<select id="vrf-min" name="minute" required aria-label="Minute">' + buildMinuteOptions() + '</select>',
                '<select id="vrf-ampm" name="ampm" required aria-label="AM/PM"><option value="AM">AM</option><option value="PM">PM</option></select>',
              '</div>',
            '</div>',
          '</div>',
          '<div class="vrf-field vrf-city-wrap">',
            '<label class="vrf-label" for="vrf-city">Birth City</label>',
            '<input type="text" id="vrf-city" name="city" placeholder="Type any city worldwide" autocomplete="off" required />',
            '<div class="vrf-city-list" role="listbox"></div>',
            '<div class="vrf-helper">If your village isn\'t found, enter the nearest large city — calculations remain accurate.</div>',
          '</div>',
          '<div style="text-align:center;margin-top:14px">',
            '<button type="submit" class="vrf-cta">Reveal My Remedy <span class="vrf-cta-arrow">→</span></button>',
          '</div>',
        '</form>',
        '<div class="vrf-trust">',
          '<span>✦ 19,000+ customers</span>',
          '<span class="vrf-trust-dot">·</span>',
          '<span>50+ countries</span>',
          '<span class="vrf-trust-dot">·</span>',
          '<span>Lab-certified gemstones</span>',
        '</div>',
        '<div class="vrf-palm-cta">',
          '<div class="vrf-palm-cta-icon" aria-hidden="true">✋</div>',
          '<div class="vrf-palm-cta-body">',
            '<div class="vrf-palm-cta-eyebrow">Don\'t know your birth time?</div>',
            '<h3 class="vrf-palm-cta-title">Try a <em>palm-based</em> reading instead</h3>',
            '<p class="vrf-palm-cta-desc">Our expert palmists can recommend your gemstone, rudraksha &amp; puja from photos of your palms — a 5,000-year-old <em>Samudrika Shastra</em> method, delivered as a full personalised report.</p>',
            '<a href="' + GEMSTONE_REPORT_URL + '" class="vrf-palm-cta-btn">Get Palm-Based Report →</a>',
          '</div>',
        '</div>',
        '<div class="vrf-foot">Rooted in classical Vedanga Jyotisa principles · Calculations against real ephemeris data</div>',
      '</div>'
    ].join('');
  }

  function buildMinuteOptions() {
    var html = '<option value="">--</option>';
    for (var i = 0; i < 60; i++) html += '<option value="' + i + '">' + String(i).padStart(2, '0') + '</option>';
    return html;
  }
  function buildYearOptions() {
    var html = '<option value="">--</option>';
    var current = new Date().getFullYear();
    for (var y = current; y >= 1925; y--) html += '<option value="' + y + '">' + y + '</option>';
    return html;
  }

  function bindForm(root) {
    var form = $('.vrf-form', root);
    var cityInput = $('#vrf-city', root);
    var cityList = $('.vrf-city-list', root);
    var selectedCity = null;
    var fetchCities = debounce(function (q) {
      if (q.length < 2) { cityList.classList.remove('open'); return; }
      cityList.innerHTML = '<div class="vrf-city-loading">Searching…</div>';
      cityList.classList.add('open');
      fetch(WORKER_URL + '?action=geocode&q=' + encodeURIComponent(q))
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var results = (data && data.results) || [];
          if (!results.length) {
            cityList.innerHTML = '<div class="vrf-city-empty">No matches. Try a nearby larger city.</div>';
            return;
          }
          cityList.innerHTML = results.map(function (r, i) {
            var sub = [r.admin, r.country].filter(Boolean).join(', ');
            return '<div class="vrf-city-item" data-i="' + i + '">' +
              escapeHtml(r.name) +
              (sub ? '<span class="vrf-city-item-sub">' + escapeHtml(sub) + '</span>' : '') +
              '</div>';
          }).join('');
          cityList._results = results;
        })
        .catch(function () { cityList.innerHTML = '<div class="vrf-city-empty">Search failed. Try again.</div>'; });
    }, 280);
    cityInput.addEventListener('input', function () { selectedCity = null; fetchCities(this.value.trim()); });
    cityInput.addEventListener('focus', function () { if (cityList.children.length) cityList.classList.add('open'); });
    cityList.addEventListener('click', function (e) {
      var item = e.target.closest('.vrf-city-item');
      if (!item || !cityList._results) return;
      var idx = +item.dataset.i;
      selectedCity = cityList._results[idx];
      var sub = [selectedCity.admin, selectedCity.country].filter(Boolean).join(', ');
      cityInput.value = selectedCity.name + (sub ? ', ' + sub : '');
      cityList.classList.remove('open');
    });
    document.addEventListener('click', function (e) {
      if (!cityInput.contains(e.target) && !cityList.contains(e.target)) cityList.classList.remove('open');
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(root, form, selectedCity); });
  }

  function submit(root, form, selectedCity) {
    var day = +$('#vrf-day', root).value;
    var month = +$('#vrf-month', root).value;
    var year = +$('#vrf-year', root).value;
    var hour = +$('#vrf-hour', root).value;
    var minute = +$('#vrf-min', root).value;
    var ampm = $('#vrf-ampm', root).value;
    if (!day || !month || !year || isNaN(hour) || isNaN(minute) || !selectedCity) {
      showError(root, 'Please fill in all fields and select a city from the list.');
      return;
    }
    var h24 = hour;
    if (ampm === 'PM' && h24 !== 12) h24 += 12;
    if (ampm === 'AM' && h24 === 12) h24 = 0;
    var dateStr = year + '-' + String(month).padStart(2, '0') + '-' + String(day).padStart(2, '0');
    var timeStr = String(h24).padStart(2, '0') + ':' + String(minute).padStart(2, '0') + ':00';
    var tz = getTzOffsetForLocation(selectedCity.tz, dateStr + 'T' + timeStr);
    var datetime = dateStr + 'T' + timeStr + tz;
    var cacheKey = CACHE_KEY_PREFIX + hashStr(datetime + '|' + selectedCity.lat.toFixed(4) + '|' + selectedCity.lng.toFixed(4));
    try {
      var cached = localStorage.getItem(cacheKey);
      if (cached) {
        var parsed = JSON.parse(cached);
        if (parsed.t && (Date.now() - parsed.t) < CACHE_TTL_MS && parsed.r) {
          showResult(root, parsed.r);
          return;
        }
      }
    } catch (e) {}
    showLoading(root);
    fetch(WORKER_URL + '?action=remedy&datetime=' + encodeURIComponent(datetime) + '&lat=' + selectedCity.lat + '&lng=' + selectedCity.lng)
      .then(function (r) { return r.json().then(function (data) { return { status: r.status, data: data }; }); })
      .then(function (resp) {
        if (resp.status === 429) { showError(root, resp.data.message || 'Rate limit reached. Try later.', resp.data.contact); return; }
        if (resp.status !== 200 || resp.data.error) { showError(root, resp.data.message || resp.data.error || 'Something went wrong. Please try again.'); return; }
        try { localStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), r: resp.data })); } catch (e) {}
        showResult(root, resp.data);
      })
      .catch(function (err) { showError(root, 'Network error: ' + err.message); });
  }

  function hashStr(s) {
    var h = 0;
    for (var i = 0; i < s.length; i++) { h = ((h << 5) - h) + s.charCodeAt(i); h |= 0; }
    return Math.abs(h).toString(36);
  }

  function showLoading(root) {
    root.innerHTML = '<div class="vrf-loading"><div class="vrf-spinner"></div><div>Reading your stars…</div></div>';
  }

  function showError(root, msg, contactUrl) {
    var contactLine = contactUrl ? '<div style="margin-top:8px"><a href="' + contactUrl + '" style="color:#A8893E">Contact us for API access →</a></div>' : '';
    var errHtml = '<div class="vrf-error">' + escapeHtml(msg) + contactLine + '</div>' +
      '<div style="text-align:center;margin-top:12px"><button class="vrf-cta" data-vrf="retry">Try Again</button></div>';
    root.innerHTML = errHtml;
    var retry = $('[data-vrf="retry"]', root);
    if (retry) retry.addEventListener('click', function () { root.dataset.vrfInit = ''; init(root); });
  }

  function showResult(root, r) {
    root.innerHTML = buildResultHtml(r);
    bindResult(root, r);
    try { history.replaceState(null, '', '#lagna-' + r.lagna.toLowerCase()); } catch (e) {}
    injectProductSchema(r);
  }

  function buildKundliSvg(kundli) {
    if (!kundli || !kundli.byHouse) return '';
    var centers = {
      1: [140, 60],   2: [62, 30],    3: [30, 62],    4: [62, 140],
      5: [30, 218],   6: [62, 250],   7: [140, 220],  8: [218, 250],
      9: [250, 218], 10: [218, 140], 11: [250, 62],  12: [218, 30]
    };
    var parts = [
      '<rect x="2" y="2" width="276" height="276" fill="none" stroke="currentColor" stroke-width="1.5"/>',
      '<line x1="2" y1="2" x2="278" y2="278" stroke="currentColor" stroke-width="1.5"/>',
      '<line x1="278" y1="2" x2="2" y2="278" stroke="currentColor" stroke-width="1.5"/>',
      '<polygon points="140,2 278,140 140,278 2,140" fill="none" stroke="currentColor" stroke-width="1.5"/>'
    ];
    for (var i = 1; i <= 12; i++) {
      var c = centers[i];
      var hp = kundli.byHouse[i] || [];
      parts.push('<text x="' + c[0] + '" y="' + c[1] + '" class="vrf-k-num" text-anchor="middle">' + i + '</text>');
      if (hp.length) {
        var codes = hp.map(function (p) { return p.code + (p.retrograde ? '(R)' : ''); }).join(' ');
        parts.push('<text x="' + c[0] + '" y="' + (c[1] + 14) + '" class="vrf-k-planet" text-anchor="middle">' + codes + '</text>');
      }
      if (i === 1) parts.push('<text x="' + c[0] + '" y="' + (c[1] - 12) + '" class="vrf-k-lagna" text-anchor="middle">La</text>');
    }
    return '<svg viewBox="0 0 280 280" class="vrf-kundli-svg" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Your Vedic kundli (birth chart)">' + parts.join('') + '</svg>';
  }

  function buildPlanetTable(kundli) {
    if (!kundli || !kundli.planets || !kundli.planets.length) return '';
    var rows = kundli.planets.map(function (p) {
      var deg = (typeof p.longitude === 'number') ? (((p.longitude % 30) + 30) % 30).toFixed(1) + '°' : '—';
      var status = p.retrograde ? '<span class="vrf-k-retro">Retrograde</span>' : '<span class="vrf-k-direct">Direct</span>';
      return '<tr><td class="vrf-k-pname"><strong>' + escapeHtml(p.name) + '</strong> <span class="vrf-k-pcode">' + escapeHtml(p.code) + '</span></td>'
        + '<td>' + escapeHtml(p.rasi || '—') + '</td>'
        + '<td class="vrf-k-deg">' + deg + '</td>'
        + '<td>' + status + '</td></tr>';
    }).join('');
    var lagnaDeg = (typeof kundli.lagnaLongitude === 'number') ? (((kundli.lagnaLongitude % 30) + 30) % 30).toFixed(1) + '°' : '—';
    var lagnaRow = '<tr class="vrf-k-lagna-row"><td class="vrf-k-pname"><strong>Ascendant</strong> <span class="vrf-k-pcode">La</span></td>'
      + '<td>' + escapeHtml(kundli.lagnaRasi || '—') + '</td>'
      + '<td class="vrf-k-deg">' + lagnaDeg + '</td><td>—</td></tr>';
    return '<div class="vrf-k-table-wrap"><div class="vrf-k-table-title">Planetary Positions</div>'
      + '<table class="vrf-k-table"><thead><tr><th>Planet</th><th>Sign</th><th>Degree</th><th>Motion</th></tr></thead>'
      + '<tbody>' + lagnaRow + rows + '</tbody></table></div>';
  }

  function buildResultHtml(r) {
    var subHtml = '<strong>Affordable alternative:</strong> ' +
      '<a href="' + r.gemstone.substitute.url + '">' + escapeHtml(r.gemstone.substitute.name) + '</a>';
    if (r.gemstone.substitute.alt) {
      subHtml += ' <span style="opacity:0.7">or</span> ' +
        '<a href="' + r.gemstone.substitute.alt.url + '">' + escapeHtml(r.gemstone.substitute.alt.name) + '</a>';
    }
    var snapshotHtml = '';
    if (r.birthChart && (r.birthChart.sunSign || r.birthChart.moonSign || r.birthChart.nakshatra)) {
      var bc = r.birthChart;
      var sunItem = bc.sunSign ? '<div class="vrf-snap-item"><div class="vrf-snap-icon" aria-hidden="true">☉</div><div class="vrf-snap-label">Sun Sign</div><div class="vrf-snap-value">' + escapeHtml(bc.sunSign) + (bc.sunSignSanskrit && bc.sunSignSanskrit.toLowerCase() !== bc.sunSign.toLowerCase() ? ' <span class="vrf-snap-sub">(' + escapeHtml(bc.sunSignSanskrit) + ')</span>' : '') + '</div></div>' : '';
      var moonItem = bc.moonSign ? '<div class="vrf-snap-item"><div class="vrf-snap-icon" aria-hidden="true">☽</div><div class="vrf-snap-label">Moon Sign</div><div class="vrf-snap-value">' + escapeHtml(bc.moonSign) + (bc.moonSignSanskrit && bc.moonSignSanskrit.toLowerCase() !== bc.moonSign.toLowerCase() ? ' <span class="vrf-snap-sub">(' + escapeHtml(bc.moonSignSanskrit) + ')</span>' : '') + '</div></div>' : '';
      var nakItem = bc.nakshatra ? '<div class="vrf-snap-item"><div class="vrf-snap-icon" aria-hidden="true">✦</div><div class="vrf-snap-label">Nakshatra</div><div class="vrf-snap-value">' + escapeHtml(bc.nakshatra) + (bc.pada ? ' <span class="vrf-snap-sub">Pada ' + escapeHtml(String(bc.pada)) + '</span>' : '') + '</div></div>' : '';
      if (sunItem || moonItem || nakItem) {
        snapshotHtml = '<div class="vrf-snapshot"><div class="vrf-snap-eyebrow">Your Vedic Birth Chart Snapshot</div><div class="vrf-snap-grid">' + sunItem + moonItem + nakItem + '</div></div>';
      }
    }
    var doshasHtml = '';
    var pujaUrl = r.doshaPujaUrl || '/collections/navgrah-pooja-navagraha-graha-shanti';
    var doshaParts = [];
    if (r.manglik) {
      if (r.manglik.has) {
        doshaParts.push('<div class="vrf-dosha-card vrf-dosha-active"><div class="vrf-dosha-icon" aria-hidden="true">⚠</div><div class="vrf-dosha-body"><div class="vrf-dosha-title">Mangal Dosha Present</div><div class="vrf-dosha-desc">Mars (Mangal) is afflicting key houses in your chart — traditionally associated with friction in marriage, partnerships, and impulsive decisions. A targeted Mangal Pooja is the classical Vedic remedy.</div><a href="' + pujaUrl + '" class="vrf-dosha-link">Pacify with Mangal Pooja →</a></div></div>');
      } else {
        doshaParts.push('<div class="vrf-dosha-clear"><span class="vrf-dosha-check" aria-hidden="true">✓</span> <strong>No Mangal Dosha</strong> — Mars sits favourably for you.</div>');
      }
    }
    if (r.kaalSarp) {
      if (r.kaalSarp.has) {
        var ksTypeLabel = r.kaalSarp.type ? ' (' + escapeHtml(r.kaalSarp.type) + ')' : '';
        doshaParts.push('<div class="vrf-dosha-card vrf-dosha-active"><div class="vrf-dosha-icon" aria-hidden="true">⚠</div><div class="vrf-dosha-body"><div class="vrf-dosha-title">Kaal Sarp Dosha Present' + ksTypeLabel + '</div><div class="vrf-dosha-desc">All seven planets are positioned between Rahu and Ketu in your chart. This shadow-planet alignment can manifest as sudden setbacks, delayed success, and recurring obstacles. The classical remedy is a Rahu-Ketu Shanti Pooja.</div><a href="' + pujaUrl + '" class="vrf-dosha-link">Pacify with Rahu-Ketu Pooja →</a></div></div>');
      } else {
        doshaParts.push('<div class="vrf-dosha-clear"><span class="vrf-dosha-check" aria-hidden="true">✓</span> <strong>No Kaal Sarp Dosha</strong> — Rahu and Ketu do not enclose your planets.</div>');
      }
    }
    if (r.sadeSati) {
      if (r.sadeSati.active) {
        var phaseLabel = r.sadeSati.phase ? ' — ' + escapeHtml(r.sadeSati.phase) + ' phase' : '';
        doshaParts.push('<div class="vrf-dosha-card vrf-dosha-active"><div class="vrf-dosha-icon" aria-hidden="true">⚠</div><div class="vrf-dosha-body"><div class="vrf-dosha-title">Sade Sati Active' + phaseLabel + '</div><div class="vrf-dosha-desc">Saturn (Shani) is transiting the 12th, 1st, or 2nd house from your Moon — the 7.5-year period traditionally associated with karmic restructuring, delays, and tests of endurance. A Shani Shanti Pooja reduces its harshness.</div><a href="' + pujaUrl + '" class="vrf-dosha-link">Pacify with Shani Pooja →</a></div></div>');
      } else {
        doshaParts.push('<div class="vrf-dosha-clear"><span class="vrf-dosha-check" aria-hidden="true">✓</span> <strong>Not in Sade Sati</strong> — Saturn is not currently afflicting your Moon.</div>');
      }
    }
    if (doshaParts.length) {
      doshasHtml = '<div class="vrf-doshas"><div class="vrf-doshas-eyebrow">Important Insights From Your Chart</div>' + doshaParts.join('') + '</div>';
    }
    return [
      '<div class="vrf-result-header">',
        '<div class="vrf-result-eyebrow">Your Vedic Birth Chart</div>',
        '<h2 class="vrf-result-title">Ascendant: <em>' + escapeHtml(r.lagna) + ' (' + escapeHtml(r.lagnaSanskrit) + ')</em></h2>',
        '<div class="vrf-result-lord">Ruled by <strong>' + escapeHtml(r.lord) + ' (' + escapeHtml(r.lordSanskrit) + ')</strong></div>',
      '</div>',
      snapshotHtml,
      r.kundli && r.kundli.byHouse
        ? ('<details class="vrf-kundli-details"><summary class="vrf-kundli-summary"><span class="vrf-kundli-eyebrow">Your Vedic Kundli (Birth Chart)</span><span class="vrf-kundli-toggle">View ↓</span></summary><div class="vrf-kundli-body">' + buildKundliSvg(r.kundli) + buildPlanetTable(r.kundli) + '<div class="vrf-kundli-legend"><strong>Su</strong> Sun · <strong>Mo</strong> Moon · <strong>Ma</strong> Mars · <strong>Me</strong> Mercury · <strong>Ju</strong> Jupiter · <strong>Ve</strong> Venus · <strong>Sa</strong> Saturn · <strong>Ra</strong> Rahu · <strong>Ke</strong> Ketu · <strong>La</strong> Lagna · <strong>(R)</strong> Retrograde</div></div></details>')
        : '',
      '<div class="vrf-cards">',
        '<div class="vrf-card"><div class="vrf-card-icon gem">◯</div><div class="vrf-card-body"><div class="vrf-card-eyebrow">Your Lucky Gemstone</div><h3 class="vrf-card-title">' + escapeHtml(r.gemstone.name) + ' <em>(' + escapeHtml(r.gemstone.sanskrit) + ')</em></h3><p class="vrf-card-desc">' + escapeHtml(r.gemstone.description) + '</p><div class="vrf-card-sub">' + subHtml + '</div><a href="' + r.gemstone.url + '" class="vrf-card-link">Shop ' + escapeHtml(r.gemstone.name) + ' →</a></div></div>',
        '<div class="vrf-card"><div class="vrf-card-icon rud">' + escapeHtml(getRudNum(r.rudraksha.name)) + '</div><div class="vrf-card-body"><div class="vrf-card-eyebrow">Your Lucky Rudraksha</div><h3 class="vrf-card-title">' + escapeHtml(r.rudraksha.name) + '</h3><p class="vrf-card-desc">' + escapeHtml(r.rudraksha.description) + '</p><a href="' + r.rudraksha.url + '" class="vrf-card-link">Shop Rudraksha →</a></div></div>',
        '<div class="vrf-card"><div class="vrf-card-icon puja">𑗉</div><div class="vrf-card-body"><div class="vrf-card-eyebrow">Recommended Puja</div><h3 class="vrf-card-title">' + escapeHtml(r.puja.name) + '</h3><p class="vrf-card-desc">' + escapeHtml(r.puja.description) + '</p><a href="' + r.puja.url + '" class="vrf-card-link">Book Puja →</a></div></div>',
      '</div>',
      doshasHtml,
      '<div class="vrf-email" data-vrf="email">',
        '<span class="vrf-email-icon">✉</span>',
        '<span class="vrf-email-label">Email me my Vedic remedy</span>',
        '<form class="vrf-email-form" data-vrf-result=\'' + escapeAttr(JSON.stringify({ lagna: r.lagna, gem: r.gemstone.name, rud: r.rudraksha.name, puja: r.puja.name })) + '\'>',
          '<input type="email" placeholder="your@email.com" required />',
          '<button type="submit">Send</button>',
        '</form>',
      '</div>',
      '<div class="vrf-upsell">',
        '<h3>Want the <em>full picture</em>?</h3>',
        '<p>A complete report analyses your dashas, planetary positions, doshas, and yogas — and gives you a precise action plan from our 124+ astrologer panel.</p>',
        '<div class="vrf-upsell-actions">',
          '<a href="' + GEMSTONE_REPORT_URL + '" class="vrf-btn-primary">Get Full Personalised Report</a>',
          '<a href="' + r.gemstone.url + '" class="vrf-btn-secondary">Shop Your ' + escapeHtml(r.gemstone.name) + '</a>',
        '</div>',
      '</div>'
    ].join('');
  }

  function getRudNum(name) {
    var m = (name || '').match(/^(\d+)/);
    return m ? m[1] : '◊';
  }

  function bindResult(root, r) {
    var emailForm = $('.vrf-email-form', root);
    if (!emailForm) return;
    emailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var emailInput = emailForm.querySelector('input[type=email]');
      var submitBtn = emailForm.querySelector('button');
      var email = emailInput.value.trim();
      if (!email) return;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending…';
      var lines = [
        'Vedic Remedy Finder — Personalised Report', '',
        '━━━ Your Details ━━━',
        'Email:           ' + email, '',
        '━━━ Your Vedic Birth Chart ━━━',
        'Ascendant (Lagna): ' + r.lagna + ' (' + r.lagnaSanskrit + ')',
        'Ruling Planet:     ' + r.lord + ' (' + r.lordSanskrit + ')'
      ];
      if (r.birthChart) {
        if (r.birthChart.sunSign)   lines.push('Sun Sign:          ' + r.birthChart.sunSign + (r.birthChart.sunSignSanskrit && r.birthChart.sunSignSanskrit !== r.birthChart.sunSign ? ' (' + r.birthChart.sunSignSanskrit + ')' : ''));
        if (r.birthChart.moonSign)  lines.push('Moon Sign (Rashi): ' + r.birthChart.moonSign + (r.birthChart.moonSignSanskrit && r.birthChart.moonSignSanskrit !== r.birthChart.moonSign ? ' (' + r.birthChart.moonSignSanskrit + ')' : ''));
        if (r.birthChart.nakshatra) lines.push('Nakshatra:         ' + r.birthChart.nakshatra + (r.birthChart.pada ? ', Pada ' + r.birthChart.pada : ''));
      }
      lines.push('');
      lines.push('━━━ Your Recommended Remedies ━━━');
      lines.push('Gemstone:  ' + r.gemstone.name + ' (' + r.gemstone.sanskrit + ')');
      lines.push('           Substitute: ' + r.gemstone.substitute.name);
      lines.push('Rudraksha: ' + r.rudraksha.name);
      lines.push('Puja:      ' + r.puja.name);
      lines.push('');
      lines.push('━━━ Dosha & Transit Analysis ━━━');
      if (r.manglik)  lines.push('Mangal Dosha:    ' + (r.manglik.has  ? 'PRESENT — recommend Mangal Pooja' : 'Not present'));
      if (r.kaalSarp) lines.push('Kaal Sarp Dosha: ' + (r.kaalSarp.has ? ('PRESENT' + (r.kaalSarp.type ? ' (' + r.kaalSarp.type + ')' : '') + ' — recommend Rahu-Ketu Pooja') : 'Not present'));
      if (r.sadeSati) lines.push('Sade Sati:       ' + (r.sadeSati.active ? ('ACTIVE' + (r.sadeSati.phase ? ' (' + r.sadeSati.phase + ' phase)' : '') + ' — recommend Shani Pooja') : 'Not currently active'));
      lines.push('');
      lines.push('━━━ Source ━━━');
      lines.push('Page: ' + window.location.href);
      lines.push('Generated: ' + new Date().toISOString());
      var body = lines.join('\n');
      var csrf = document.querySelector('input[name="authenticity_token"]') || document.querySelector('meta[name="csrf-token"]');
      var token = csrf ? (csrf.value || csrf.content) : '';
      var formBody = 'contact[name]=' + encodeURIComponent('VRF — ' + r.lagna) +
        '&contact[email]=' + encodeURIComponent(email) +
        '&contact[body]=' + encodeURIComponent(body) +
        '&form_type=contact&utf8=%E2%9C%93';
      if (token) formBody += '&authenticity_token=' + encodeURIComponent(token);
      fetch('/contact#contact_form', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: formBody }).catch(function () {});
      try {
        var f = document.createElement('form');
        f.method = 'POST'; f.action = '/contact#contact_form'; f.style.display = 'none';
        f.target = 'vrf_email_frame';
        var fields = { 'contact[name]': 'VRF — ' + r.lagna, 'contact[email]': email, 'contact[body]': body, 'form_type': 'contact', 'utf8': '✓' };
        if (token) fields.authenticity_token = token;
        Object.keys(fields).forEach(function (k) {
          var i = document.createElement('input');
          i.type = 'hidden'; i.name = k; i.value = fields[k];
          f.appendChild(i);
        });
        var ifr = document.createElement('iframe');
        ifr.name = 'vrf_email_frame'; ifr.style.display = 'none';
        document.body.appendChild(ifr); document.body.appendChild(f); f.submit();
        setTimeout(function () { f.remove(); ifr.remove(); }, 5000);
      } catch (e) {}
      setTimeout(function () {
        emailForm.parentNode.innerHTML = '<div class="vrf-email-sent">✓ Sent. Your Vedic remedy is on its way to your inbox.</div>';
      }, 500);
    });
  }

  function injectProductSchema(r) {
    var old = document.getElementById('vrf-product-schema');
    if (old) old.remove();
    var schema = {
      '@context': 'https://schema.org', '@type': 'Product',
      'name': r.gemstone.name + ' (' + r.gemstone.sanskrit + ')',
      'description': r.gemstone.description + ' Recommended for ' + r.lagna + ' (' + r.lagnaSanskrit + ') ascendants.',
      'url': window.location.origin + r.gemstone.url,
      'brand': { '@type': 'Brand', 'name': 'Vedic Crystals' },
      'category': 'Vedic Astrological Gemstones'
    };
    var s = document.createElement('script');
    s.type = 'application/ld+json'; s.id = 'vrf-product-schema';
    s.textContent = JSON.stringify(schema);
    document.head.appendChild(s);
  }

  function escapeHtml(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function escapeAttr(s) { return String(s || '').replace(/'/g, '&#39;').replace(/"/g, '&quot;'); }

  function start() {
    $$('.vrf').forEach(function (root) {
      if (root.closest('article') || root.closest('.article-template')) {
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) { init(entry.target); io.unobserve(entry.target); }
            });
          }, { rootMargin: '200px' });
          io.observe(root);
        } else { init(root); }
      } else { init(root); }
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
